// Initial state is the place you define all initial values for the Redux store of the feature.
// In the 'standard' way, initialState is defined in reducers: http://redux.js.org/docs/basics/Reducers.html
// But when application grows, there will be multiple reducers files, it's not intuitive what data is managed by the whole store.
// So Rekit extracts the initial state definition into a separate module so that you can have
// a quick view about what data is used for the feature, at any time.

// NOTE: initialState constant is necessary so that Rekit could auto add initial state when creating async actions.
const initialState = {
  getListMaestroPending: false,
  getListMaestroError: null,
  dataFromMaestro: null,

  loadSchemasFromMaestroPending: false,
  loadSchemasFromMaestroError: null,
  categories: [],
  basicInfoSchema: null,
  totalFields: 0,
  advancedInfoSchema: null,
  requiredFields: [],

  dataList: null, //esta variable se usa para el componente List
  searchData: '',
  getBrandsPending: false,
  getBrandsError: null,
  brandListOrigin: [],
  brandList: [],
  updateBrandPending: false,
  updateBrandError: null,
  modelListOrigin: [],
  modelList: [],
  updateModelPending: false,
  updateModelError: null,
  createModelPending: false,
  createModelError: null,
  deleteBrandPending: false,
  deleteBrandError: null,
  deleteModelPending: false,
  deleteModelError: null,
  createCompanyPending: false,
  createCompanyError: null,
  deleteCompanyPending: false,
  deleteCompanyError: null,
  getCompaniesPending: false,
  getCompaniesError: null,
  companyListOrigin: [],
  companyList: [],
  updateCompanyPending: false,
  updateCompanyError: null,
  versionListOrigin: [],
  versionList: [],
  createVersionPending: false,
  createVersionError: null,
  deleteVersionPending: false,
  deleteVersionError: null,
  getVersionsPending: false,
  getVersionsError: null,
  updateVersionPending: false,
  updateVersionError: null,
  modelByBrandListOrigin: [],
  modelByBrandList: [],
  getModelsByBrandPending: false,
  getModelsByBrandError: null,
  createCarDealershipPending: false,
  createCarDealershipError: null,
  deleteCarDealershipPending: false,
  deleteCarDealershipError: null,
  getCarDealershipsPending: false,
  getCarDealershipsError: null,
  updateCarDealershipPending: false,
  updateCarDealershipError: null,
  carDealershipListOrigin: [],
  carDealershipList: [],
  validateCuitCarDealershipPending: false,
  validateCuitCarDealershipError: null,
  getModelsPending: false,
  getModelsError: null,
  createBranchPending: false,
  createBranchError: null,
  deleteBranchPending: false,
  deleteBranchError: null,
  getBranchesPending: false,
  getBranchesError: null,
  branchListOrigin: [],
  branchList: [],
  updateBranchPending: false,
  updateBranchError: null,
  validateCuitBranchPending: false,
  validateCuitBranchError: null,
  brandsPagination: {
    total: 0,
    page: 1,
    pages: 1,
    nextPage: null,
    prevPage: null
  },
  modelsPagination: {
    total: 0,
    page: 1,
    pages: 1,
    nextPage: null,
    prevPage: null
  },
  versionsPagination: {
    total: 0,
    page: 1,
    pages: 1,
    nextPage: null,
    prevPage: null
  },
  companiesPagination: {
    total: 0,
    page: 1,
    pages: 1,
    nextPage: null,
    prevPage: null
  },
  carDealershipsPagination: {
    total: 0,
    page: 1,
    pages: 1,
    nextPage: null,
    prevPage: null
  },
  branchesPagination: {
    total: 0,
    page: 1,
    pages: 1,
    nextPage: null,
    prevPage: null
  },
  locationsPagination: {
    total: 0,
    page: 1,
    pages: 1,
    nextPage: null,
    prevPage: null
  },
  businessUnitsPagination: {
    total: 0,
    page: 1,
    pages: 1,
    nextPage: null,
    prevPage: null
  },
  legalDocsPagination: {
    total: 0,
    page: 1,
    pages: 1,
    nextPage: null,
    prevPage: null
  },
  bankAccountsPagination: {
    total: 0,
    page: 1,
    pages: 1,
    nextPage: null,
    prevPage: null
  },
  createLocationPending: false,
  createLocationError: null,
  deleteLocationPending: false,
  deleteLocationError: null,
  getLocationsPending: false,
  getLocationsError: null,
  locationList: [],
  branchByCarDealershipList: [],
  updateLocationPending: false,
  updateLocationError: null,
  getBranchesByCarDealershipPending: false,
  getBranchesByCarDealershipError: null,
  createBusinessUnitPending: false,
  createBusinessUnitError: null,
  deleteBusinessUnitPending: false,
  deleteBusinessUnitError: null,
  getBusinessUnitsPending: false,
  getBusinessUnitsError: null,
  businessUnitList: [],
  updateBusinessUnitPending: false,
  updateBusinessUnitError: null,
  canDeleteModelPending: false,
  canDeleteModelError: null,
  createLegalDocPending: false,
  createLegalDocError: null,
  deleteLegalDocPending: false,
  deleteLegalDocError: null,
  getLegalDocsPending: false,
  getLegalDocsError: null,
  getLegalDocTypesPending: false,
  getLegalDocTypesError: null,
  legalDocList: [],
  legalDocTypeList: [],
  updateLegalDocPending: false,
  updateLegalDocError: null,
  createBankAccountPending: false,
  createBankAccountError: null,
  deleteBankAccountPending: false,
  deleteBankAccountError: null,
  getBankAccountsPending: false,
  getBankAccountsError: null,
  bankAccountList: [],
  getFinancialEntitiesPending: false,
  getFinancialEntitiesError: null,
  updateBankAccountPending: false,
  updateBankAccountError: null,
  financialEntityList: [],
  getCurrenciesPending: false,
  getCurrenciesError: null,
  getExchangeRatesPending: false,
  getExchangeRatesError: null,
  deleteExchangeRatePending: false,
  deleteExchangeRateError: null,
  createExchangeRatePending: false,
  createExchangeRateError: null,
  updateExchangeRatePending: false,
  updateExchangeRateError: null,
  getGrantingEntitiesPending: false,
  getGrantingEntitiesError: null,
  deleteGrantingEntityPending: false,
  deleteGrantingEntityError: null,
  createGrantingEntityPending: false,
  createGrantingEntityError: null,
  updateGrantingEntityPending: false,
  updateGrantingEntityError: null,
  createCurrencyPending: false,
  createCurrencyError: null,
  deleteCurrencyPending: false,
  deleteCurrencyError: null,
  updateCurrencyPending: false,
  updateCurrencyError: null,
  getProvincesPending: false,
  getProvincesError: null,
  getPaymentMethodsPending: false,
  getPaymentMethodsError: null,
  uploadExcelPricesFinish: false,
  uploadExcelPricesError: false,
  uploadDepreciationYearPending:false,
  uploadDepreciationYearError:null,
  pricesDraftData: {
    brand: {},
    model: {},
    versionAndYear: null,
    selectedOption: null,
    rowSelected: null,
    changedInputYears: null,
    origin: null,
  }
}

export default initialState
